<!--模板-->
<template>
  <div id="orderAdd">
    <!-- ***预约步骤 -->
    <div class="sec_order_step clearfix">
      <div class="order-step-inner mid">
        <ul>
          <li><span class="s1">STEP 01</span><span class="s2">选择陪陪服务者</span></li>
          <li class="arrow"></li>
          <li><span class="s1">STEP 02</span><span class="s2">提交服务项需求</span></li>
          <li class="arrow"></li>
          <li><span class="s1">STEP 03</span><span class="s2">支付预定金</span></li>
          <li class="arrow"></li>
          <li class="on"><span class="s1">STEP 04</span><span class="s2">等待陪陪确认</span></li>
        </ul>
      </div>
    </div>
    <!-- ***预约流程(陪行) -->
    <div class="sec_order_step_wrap mid--1000 pb--50 clearfix" v-if="ServeData">
      <!-- //step 03(等待导游接受)-->
      <div class="lt_order_tips">
        <div class="success">
          <img v-if="ServeData.status == 2" src="../../../static/images/icon-order-succ.png" />
          <!--（0：待付款，1：已取消   2：待确认，3被拒绝  4：进行中，5：已完成待评价，6：已评价订单结束)-->
          <h2 v-if="ServeData.status == 0">
            <div><span>【等待付款】</span><br /><span>正在付款，请稍后~</span></div>
          </h2>
          <h2 v-if="ServeData.status == 1"><span>【订单已被取消】</span><br /> <span>买家已放弃，订单取消~</span></h2>
          <h2 v-if="ServeData.status == 2"><span>【支付成功】</span><br /> <span>正在等待陪陪服务者确认，我们将短信通知结果~</span></h2>
          <h2 v-if="ServeData.status == 3"><span>【服务被拒绝】</span><br /> <span>服务者因无时间，拒绝订单~</span></h2>
          <h2 v-if="ServeData.status == 4"><span>【服务进行中】</span><br /> <span>服务正在进行中~</span></h2>
          <h2 v-if="ServeData.status == 5"><span>【服务已完成，待评价】</span><br /> <span>服务已完成，待评价订单~</span></h2>
          <h2 v-if="ServeData.status == 6"><span>【服务已结束】</span><br /> <span>服务已结束~</span></h2>
        </div>
      </div>
      <!--申请单-->
      <div class="rt_order_list">
        <h2 class="tit">行程预订申请单</h2>
        <div class="list_inner">
          <div class="order_cancel">
            <h2 v-if="ServeData.status == 0"><b class="c--f60">【等待付款】</b></h2>
            <h2 v-if="ServeData.status == 1"><b class="c--f60">【订单已被取消】</b></h2>
            <h2 v-if="ServeData.status == 2">正在向 <b class="c--f60">{{ServeData.serves.user.name}}</b> 发出预订订单申请</h2>
            <h2 v-if="ServeData.status == 3"><b class="c--f60">【服务被拒绝】</b></h2>
            <h2 v-if="ServeData.status == 4"><b class="c--f60">【服务进行中】</b></h2>
            <h2 v-if="ServeData.status == 5"><b class="c--f60">【服务已完成，待评价】</b></h2>
            <h2 v-if="ServeData.status == 6"><b class="c--f60">【服务已结束】</b></h2>
            <a v-if="ServeData.status == 0" class="btn_cancel" style="color: #f60" @click="cancel">取消订单</a>
            <!--            <a  v-if="ServeData.status == 2" class="btn_cancel" style="color: #f60">确认接受订单</a>-->
            <!--            <a  v-if="ServeData.status == 2" class="btn_cancel" style="color: #f60">拒绝订单服务</a>-->
            <span class="money">
  						<b>总付款：CNY <i class="c--f60">{{ServeData.orderPrice}}元</i></b>
  						<em>已付预订金：CNY{{ServeData.orderPrice}}元</em>
  					</span>
          </div>
          <div class="order_detail">
            <div class="tongji"><b>需求详情</b> 行程开始({{ServeData.orderStart | time}}) - 行程结束({{ServeData.orderEnd | time}}) • {{ServeData.serveNum}}位客户</div>
            <ul>
              <li v-for="(item,index) in Number(ServeData.serveNum)" :key="item">
                <p class="guider" v-if="index == 0"><span>服务向导：<em class="c--f60">{{ServeData.serves.user.name}}</em></span></p>
                <h2 class="day">Day{{index+1}}
                  <!--<i>(2016.05.11 周三)</i>-->
                </h2>
                <span class="pos">服务城市：<a>{{ServeData.serves.serveCityStr}}</a></span>
                <div class="p1 clearfix">
                  <span class="lt fl">【{{ServeData.serves.pushTypeStr}}】{{ServeData.serves.title}}</span>
                  <em class="rt fr">CNY <b class="c--f60">{{ServeData.serves.pushPrice}}元</b></em>
                </div>
                <div class="p2 clearfix" style="margin-top:50px" v-if="index == Number(ServeData.serveNum)-1">
                  <span class="lt"><b>行程备注：</b><br></span>
                  <span class="rt">【手机号：{{ServeData.telphone}} <span v-if="ServeData.weChat != ''">微信：{{ServeData.weChat}}</span>】 <br><br> • 备注：{{ServeData.remark}}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div style="border-top:3px solid #ddd;padding-top:10px;text-align: center;line-height: 57px;">
        <h3>请使用微信支付：</h3>
        <h5>总付款：CNY <i class="c--f60">{{ServeData.orderPrice}}元</i></h5>
        <qriously :value="zhifuImg" :size="200" />
        <!-- <p>{{zhifuImg}}</p> -->
      </div>
      <!--      <div class="btn_next_step"><a class="btn_next"   @click="tui">退款</a></div>-->
      <!-- <div class="btn_next_step" v-if="ServeData.status == 0"><a class="btn_next"   @click="addMoney">支付</a></div> -->
      <!-- <div class="btn_next_step" v-if="ServeData.status == 2"><a class="btn_next"  style="background: #00aaff"  @click="$router.push('/home/order')">恭喜您：支付成功，查看此订单</a></div> -->
    </div>
    <!-- 支付二维码 -->
    <el-dialog title="请使用微信支付（微信二维码）扫描" :visible.sync="zhifuShow" width="50%" :before-close="handleClose">
      <div>
        <!-- <img :src="zhifuImg" alt=""> -->
        <b>总付款：CNY <i class="c--f60">{{ServeData.orderPrice}}元</i></b>
        <p>{{zhifuImg}}</p>
      </div>
    </el-dialog>
  </div>
</template>


<!--JS-->
<script>
  import {
    selectServeOrder,
    codeURL,
    refund,
    queryOrderStatus,
    canelOrderByUser
  } from '@/api/apis'
  export default {
    data() {
      return {
        ServeData: '',
        OrderStatus: false,
        zhifuShow: false,
        zhifuImg: ''
      };
    },
    methods: {
      cancel() {
          let vm = this
        canelOrderByUser({
          orderNum: vm.$route.query.orderNum,
          status:1
        }).then((res) => {
          if (res.code == '000000') {
            vm.$message.success('订单取消')
            vm.$router.go(-2)
          } else {
            vm.$message.warning(res.msg)
          }
        })
      },
      handleClose() {
        this.zhifuShow = false
      },
      tui() {
        let vm = this
        refund({
          orderNum: vm.$route.query.orderNum
        }).then((res) => {
          if (res.code == '000000') {
          } else {
            vm.$message.warning(res.msg)
          }
        })
      },
      addMoney() {
        let vm = this
        codeURL({
          orderNum: vm.$route.query.orderNum
        }).then((res) => {
          if (res.code == '000000') {
            vm.zhifuShow = true
            vm.zhifuImg = res.data
          } else {
            vm.$message.warning(res.msg)
          }
        })
      }
    },
    mounted() {
      let vm = this
      // 获取支付二维码
      codeURL({
        orderNum: vm.$route.query.orderNum
      }).then((res) => {
        if (res.code == '000000') {
          vm.zhifuImg = res.data
        } else {
          vm.$message.warning(res.msg)
        }
      })
      // 获取订单状态
      queryOrderStatus({
        orderNum: vm.$route.query.orderNum
      }).then((res) => {
        if (res.code == '000000') {
          vm.OrderStatus = res.data
        } else {
          vm.$message.warning(res.msg)
        }
      })
      // 获取订单详情
      selectServeOrder({
        orderNum: vm.$route.query.orderNum
      }).then((res) => {
        if (res.code == '000000') {
          vm.ServeData = res.data
        } else {
          vm.$message.warning(res.msg)
        }
      })
      setInterval(() => {
        // 获取订单状态
        queryOrderStatus({
          orderNum: vm.$route.query.orderNum
        }).then((res) => {
          if (res.code == '000000') {
            vm.OrderStatus = res.data
          }
        })
        // 获取订单详情
        selectServeOrder({
          orderNum: vm.$route.query.orderNum
        }).then((res) => {
          if (res.code == '000000') {
            vm.ServeData = res.data
          }
        })
      }, 5000)
    },
    filters: {
      time: function(value) {
        var time = new Date(value * 1000);
        function add0(m) {
          return m < 10 ? '0' + m : m
        }
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        var timeResult = y + '/' + add0(m) + '/' + add0(d) + ' ' + add0(h) + ':' + add0(mm);
        if (timeResult == '1970-01-01' || timeResult == '1970-01-02') {
          return '--'
        } else {
          return timeResult
        }
      }
    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  /*等待导游接受*/
  .sec_order_step_wrap {
    margin-top: 30px;
  }
  .sec_order_step_wrap .lt_order_tips {
    float: left;
    text-align: center;
    width: 430px;
  }
  .sec_order_step_wrap .lt_order_tips .success {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    margin-top: 200px;
  }
  .sec_order_step_wrap .lt_order_tips .success h2 {
    color: #666;
    font-size: 18px;
    margin-top: 10px;
    line-height: 30px;
  }
  /*列表*/
  .sec_order_step_wrap .rt_order_list {
    float: right;
    width: 550px;
  }
  .rt_order_list .tit {
    color: #666;
    font-size: 16px;
  }
  .rt_order_list .list_inner {
    background: #fff;
    border: 1px solid #ddd;
    margin-top: 10px;
    box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -webkit-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
    -moz-box-shadow: 0 0 5px rgba(200, 200, 200, 0.4);
  }
  .rt_order_list .list_inner .order_cancel {
    border-bottom: 1px solid #ddd;
    padding: 15px 15px 25px;
    position: relative;
  }
  .rt_order_list .list_inner .order_cancel h2 {
    color: #666;
    font-size: 18px;
  }
  .rt_order_list .list_inner .order_cancel .btn_cancel {
    cursor: pointer;
    background: #f8f8f8;
    border: 1px solid #bbb;
    border-radius: 3px;
    color: #333;
    display: block;
    font: 14px/30px "sans-serif";
    margin-top: 10px;
    text-align: center;
    height: 30px;
    width: 90px;
  }
  .rt_order_list .list_inner .order_cancel .btn_cancel:hover {
    background: #f2f2f2;
  }
  .rt_order_list .list_inner .order_cancel .money {
    text-align: right;
    position: absolute;
    top: 16px;
    right: 15px;
  }
  .rt_order_list .list_inner .order_cancel .money b {
    display: block;
    font-size: 20px;
  }
  .rt_order_list .list_inner .order_cancel .money em {
    font-size: 14px;
  }
  .rt_order_list .list_inner .order_detail .tongji {
    background: #eee;
    color: #999;
    font-size: 14px;
    padding: 15px;
  }
  .rt_order_list .list_inner .order_detail .tongji b {
    color: #333;
    font-size: 18px;
  }
  .rt_order_list .list_inner .order_detail ul li {
    border-top: 1px solid #ddd;
    padding: 15px;
  }
  .rt_order_list .list_inner .order_detail ul li .guider {
    color: #333;
    font-size: 18px;
    padding-bottom: 15px;
    text-align: center;
    line-height: 26px;
  }
  .rt_order_list .list_inner .order_detail ul li .guider span {
    background: #f8f8f8;
    border-radius: 20px;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    padding: 0 15px;
    box-shadow: 1px 1px 3px rgba(200, 200, 200, 0.5);
    -webkit-box-shadow: 1px 1px 3px rgba(200, 200, 200, 0.5);
    -moz-box-shadow: 1px 1px 3px rgba(200, 200, 200, 0.5);
  }
  .rt_order_list .list_inner .order_detail ul li .day {
    color: #333;
    font-size: 20px;
  }
  .rt_order_list .list_inner .order_detail ul li .day i {
    color: #777;
    font-size: 14px;
  }
  .rt_order_list .list_inner .order_detail ul li .pos {
    display: block;
  }
  .rt_order_list .list_inner .order_detail ul li .pos a {
    background: #f60;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    margin: 5px 5px 5px 0;
    padding: 0 10px;
  }
  .rt_order_list .list_inner .order_detail ul li .p1,
  .rt_order_list .list_inner .order_detail ul li .p2 {
    background: #f5f5f5;
    color: #333;
    margin-top: 10px;
    padding: 10px;
  }
  .rt_order_list .list_inner .order_detail ul li .p1 .lt {
    background: url(../../../static/images/icon-basic-serv.png) no-repeat left center;
    padding-left: 16px;
  }
  .rt_order_list .list_inner .order_detail ul li .p2 .lt {
    background: url(../../../static/images/icon-trip-beizhu.png) no-repeat left center;
    padding-left: 20px;
  }
  .sec_order_step_wrap .btn_next_step {
    margin-top: 50px;
    text-align: center;
  }
  .sec_order_step_wrap .btn_next_step .btn_next {
    background: #f60;
    border: 1px solid #e08c00;
    border-radius: 3px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    font-size: 18px;
    padding: 11px 0 12px;
    height: auto;
    width: 548px;
    box-shadow: 0 1px 2px rgba(50, 50, 50, 0.5);
    -webkit-box-shadow: 0 1px 2px rgba(50, 50, 50, 0.5);
    -moz-box-shadow: 0 1px 2px rgba(50, 50, 50, 0.5);
  }
  .sec_order_step_wrap .rt_order_list2 {
    float: none;
    margin: 0 auto;
  }
  .rt_order_list2 .tit {
    text-align: center;
  }
  .rt_order_list2 .order_total {
    color: #333;
    font-size: 18px;
    padding: 10px 20px 0 0;
    text-align: right;
  }
  .rt_order_list2 .contact_way {
    padding-bottom: 20px;
  }
  .rt_order_list2 .contact_way span {
    display: inline-block;
    font-size: 16px;
    margin-top: 10px;
    width: 325px;
  }
  /* ==== 预约流程(陪行) {{{ ==== */
  .sec_order_step {
    background: #eaeaea;
    height: 100px;
    box-shadow: 0 1px 3px rgba(50, 50, 50, 0.2);
    -webkit-box-shadow: 0 1px 3px rgba(50, 50, 50, 0.2);
    -moz-box-shadow: 0 1px 3px rgba(50, 50, 50, 0.2);
  }
  .sec_order_step .order-step-inner {
    text-align: center;
  }
  .sec_order_step .order-step-inner ul {
    display: inline-block;
    *display: inline;
    *zoom: 1;
  }
  .sec_order_step .order-step-inner ul li {
    display: inline-block;
    vertical-align: top;
    margin-top: 28px;
    height: 50px;
    width: 200px;
  }
  .sec_order_step .order-step-inner ul li span {
    color: #666;
    display: block;
    line-height: 22px;
  }
  .sec_order_step .order-step-inner ul li.on span {
    color: #f60;
  }
  .sec_order_step .order-step-inner ul li .s1 {
    font-size: 22px;
  }
  .sec_order_step .order-step-inner ul li .s2 {
    font-size: 15px;
    margin-top: 6px;
  }
  .sec_order_step .order-step-inner ul li.arrow {
    background: url(../../../static/images/icon-arrow-step.png) no-repeat center center;
    width: 10px;
  }
  /* }}} */
</style>



// WEBPACK FOOTER //
// src/views/order/orderAwait.vue